module.exports = __webpack_public_path__ + "static/header-img-pricing-b34b1ec3ca6c1c7f327654de326ea118.jpg";